/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import Info from 'DesignSystem/Info/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content/Content/Content/Content/Actions/Upload/Content/Documents/Content/SystemFiles/FilesTree/ImageSeries/Content/Images/Empty"
  
}) {
  return (<React.Fragment
>
<Info
  viewPath={`${viewPath}/Info`}
 text="Empty folder"
 marginLeft={8}
 marginTop={4}
/>
{children}
</React.Fragment>)
}